<template>
  <div id="communityGasOverView_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $route.params.ym }}  瓦斯登記明細總覽
          </div>
          <div class="tip">
            可檢視此年月份瓦斯登記列表
          </div>
        </div>
      </div>
      <FilterFrame
        ref="filter"
        :filter-form="gasFilter"
        @search="search"
        @clear="clearSearch()"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <span>搜尋結果共計 {{ ListData.length }} 筆</span>
          <el-button
            icon="icon-output"
            :disabled="ListData.length==0 || !canClickButton"
            round
            @click="GetExport()"
          >
            匯出
          </el-button>
          <el-button
            icon="icon-print"
            :disabled="ListData.length==0 || !canClickButton"
            round
            @click="Print()"
          >
            列印
          </el-button>
        </div>
      </div>
      <el-table
        id="tableId"
        class="list"
        :data="ListData"
      >
        <el-table-column
          type="index"
          align="left"
          width="50"
        />
        <el-table-column
          prop="TabletNote"
          align="left"
          label="戶別"
          width="250"
        />
        <el-table-column
          align="left"
          label="上次度數"
        >
          <template
            v-if="scope.row.LastInfo"
            slot-scope="scope"
          >
            <el-tooltip
              :content="scope.row.LastInfo.LastYm"
              placement="top"
            >
              <span>{{ scope.row.LastInfo.LastValue }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          :label="'('+$route.params.ym+') 本次度數'"
        >
          <template slot-scope="scope">
            <el-input
              v-if="scope.row.edited"
              :ref="'inputValue'+scope.$index"
              v-model="scope.row.GasDetailInfo.Value"
              type="number"
              placeholder="請輸入數字"
              oninput="if(value.length>5)value=value.slice(0,5)"
              onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 190 ||  event.keyCode == 110 ? false : true"
              :class="(scope.row.GasDetailInfo.Value === undefined || scope.row.GasDetailInfo.Value === '') ?'borderRed':''"
              @input="input(scope.row)"
            />
            <p v-else>
              {{ scope.row.GasDetailInfo.Value }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="登記方式"
        >
          <template
            v-if="scope.row.GasDetailInfo.CreateDate"
            slot-scope="scope"
          >
            <span
              v-if="scope.row.GasDetailInfo.FromMobile"
              class="bg_lightblue"
            >手機</span>
            <span
              v-else
              class="bg_blue"
            >現場</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="登記時間"
        >
          <template
            v-if="scope.row.GasDetailInfo.CreateDate"
            slot-scope="scope"
          >
            <span>{{ scope.row.GasDetailInfo.CreateDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.edited"
              size="mini"
              plain
              @click="editTableRow(scope.row , scope.$index)"
            >
              編輯
            </el-button>
            <el-button
              v-if="scope.row.edited"
              size="mini"
              plain
              @click="cancelTableRow(scope.row)"
            >
              取消
            </el-button>
            <el-button
              v-if="scope.row.edited"
              size="mini"
              type="danger"
              :disabled="!canClickButton"
              plain
              @click="submitTableRow(scope.row , scope.$index)"
            >
              送出
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <!-- 列印渲染區塊，已隱藏 -->
    <div
      ref="printPage"
      class="printPage"
    >
      <table>
        <thead>
          <tr>
            <th>戶別</th>
            <th>{{ $route.params.ym }}本次度數</th>
            <th>戶別</th>
            <th>{{ $route.params.ym }}本次度數</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in printData"
            :key="index"
          >
            <td>{{ item.tabletNote }}</td>
            <td>{{ item.value }}</td>
            <td>{{ item.tabletNote2 }}</td>
            <td>{{ item.value2 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { setTimeout } from 'timers'

export default {
  components: {
    FilterFrame,
    TableLoading
  },
  data () {
    return {
      filter: '',
      gasFilter: [
        {
          label: '戶別',
          name: 'household',
          type: 'house'
        }
      ],
      ListData: [],
      copyListData: [],
      printData: [],
      canClickButton: true,
      loading: false
    }
  },
  mounted () {
    this.loading = true
    this.getListData()
  },
  methods: {
    // 查詢
    search (such_val) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.filter = such_val.household === undefined ? '' : such_val.household.TabletId
        this.loading = true
        this.copyListData.forEach(item => {
          if (item.TabletId === this.filter) {
            this.ListData = []
            this.ListData.push(item)
            this.loading = false
          }
          setTimeout(() => {
            this.canClickButton = true
          }, 1000)
        })
      }
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.loading = true
        this.filter = ''
        this.ListData = this.copyListData
        this.loading = false
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
      }
    },
    // 取得列表資料
    getListData () {
      this.loading = true
      const requestData = {
        gId: this.$route.params.id
      }
      apiGas.OverView.GetGasList(
        requestData
      ).then(res => {
        if (res.data.Status === 1) {
          res.data.Data.forEach(item => {
            item.edited = false
            if (item.GasDetailInfo != null) { item.GasDetailInfo.CreateDate = item.GasDetailInfo.CreateDate !== null ? item.GasDetailInfo.CreateDate.substr(0, 16) : '' }
            if (item.LastInfo != null) { item.LastInfo.LastYm = item.LastInfo.LastYm !== null ? adjustDisplay(item.LastInfo.LastYm) : '' }
            if (item.GasDetailInfo === null) {
              item.GasDetailInfo = {}
              item.GasDetailInfo.Value = null
            }
          })
          this.ListData = res.data.Data
          this.copyListData = res.data.Data
        } else if (res.data.Status === 0) {
          console.log('可控的錯誤')
        } else {
          console.log('未知錯誤')
        }
        this.loading = false
        this.canClickButton = true
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
      function adjustDisplay (ym) {
        const ym1 = ym.toString().substr(0, 4)
        const ym2 = ym.toString().substr(-2, 2)
        return ym1.concat('-', ym2)
      }
    },
    // 編輯
    editTableRow (row, index) {
      this.canClickButton = true
      row.edited = true
      row.GasDetailInfo.copyValue = row.GasDetailInfo.Value
      this.$nextTick(() => {
        this.$refs['inputValue' + index].focus()
        this.$refs['inputValue' + index].select()
      })
    },
    // 取消
    cancelTableRow (row) {
      row.edited = false
      row.GasDetailInfo.Value = row.GasDetailInfo.copyValue
    },
    // 送出
    submitTableRow (row, index) {
      this.canClickButton = false
      if (row.GasDetailInfo.Value === undefined || row.GasDetailInfo.Value === null || row.GasDetailInfo.Value === '') {
        this.$alert('請輸入本次度數，再送出', '', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
        this.$nextTick(() => {
          this.$refs['inputValue' + index].focus()
        })
      } else {
        if (row.LastInfo !== null) {
          if (row.GasDetailInfo.Value < row.LastInfo.LastValue) {
            this.$confirm('登記度數小於上次度數，確認更改？', '', {
              confirmButtonText: '確認',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.fullScreenLoading(true)
              this.submitGasValue(row)
              row.edited = true
            }).catch(() => {
              this.cancelTableRow(row)
            })
          } else {
            this.fullScreenLoading(true)
            this.submitGasValue(row)
          }
        } else {
          this.fullScreenLoading(true)
          this.submitGasValue(row)
        }
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 送出更新的本次度數
    submitGasValue (row) {
      const queryPath = {
        gasId: this.$route.params.id,
        tabletId: row.TabletId
      }
      const requestData = {
        GasDetailValue: row.GasDetailInfo.Value
      }
      setTimeout(() => {
        apiGas.OverView.PutGasExport(
          queryPath,
          requestData
        ).then(res => {
          if (res.data.Data === true) {
            this.$alert('更新成功。', '成功', {
              confirmButtonText: '確定',
              type: 'success',
              callback: action => {}
            })
            const date = new Date()
            row.GasDetailInfo.CreateDate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${date.getHours()}:${('0' + date.getMinutes()).slice(-2)}`
            row.edited = false
            row.GasDetailInfo.FromMobile = false
          }
          this.fullScreenLoading(false)
          this.$store.commit('ifCommunityGasEdit', true)
        }).catch(err => {
          console.log('錯誤訊息：', err.response)
          if (err.response.status === 404) {
            this.loading = false
          }
        })
      }, 1000)
    },
    // 取得匯出檔案
    GetExport () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.fullScreenLoading(true)
        const requestData = {
          gId: this.$route.params.id
        }
        const config = {
          responseType: 'blob'
        }
        apiGas.OverView.GetGasExport(
          requestData,
          config
        ).then(res => {
          if (res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            const fileName = `${this.$route.params.ym}${decodeURIComponent(res.headers['content-disposition'].split(';')[2].replace(" filename*=UTF-8''", '')).trim()}`
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } else {
            console.log('未知錯誤')
          }
        }).catch(err => {
          console.log('錯誤訊息：', err.response)
          this.$message({
            message: '匯出檔案失敗，請稍後再試',
            type: 'warning'
          })
        })
      }
      this.fullScreenLoading(false)
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 列印
    Print () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.printData = []
        this.fullScreenLoading(true)
        for (let i = 1; i < this.ListData.length; i++) {
          // eslint-disable-next-line eqeqeq
          if ((i % 2) != 0) {
            this.printData.push({
              tabletNote: this.ListData[i - 1].TabletNote,
              value: this.ListData[i - 1].GasDetailInfo.Value === null ? '' : this.ListData[i - 1].GasDetailInfo.Value,
              tabletNote2: this.ListData[i].TabletNote,
              value2: this.ListData[i].GasDetailInfo.Value === null ? '' : this.ListData[i].GasDetailInfo.Value
            })
          }
        }
        const length = this.ListData.length - 1
        // eslint-disable-next-line eqeqeq
        if ((length % 2) == 0) {
          this.printData.push({
            tabletNote: this.ListData[length].TabletNote,
            value: this.ListData[length].GasDetailInfo.Value === null ? '' : this.ListData[length].GasDetailInfo.Value,
            tabletNote2: '',
            value2: ''
          })
        }
        setTimeout(() => {
          this.$print(this.$refs.printPage)
          this.fullScreenLoading(false)
          this.canClickButton = true
        }, 1000)
      }
    },
    input (row) {
      let value = row.GasDetailInfo.Value.toString()
      const position = value.indexOf('.')
      if (position !== -1) {
        console.log(value.length, position)
        value = value.substr(0, position) + value.substr(position + 1, value.length)
        console.log(value)
      }
      row.GasDetailInfo.Value = value
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>

<style lang="sass" scoped>
#communityGasOverView_main
  +mainLayer
  ::v-deep .el-table
    +basicTable
    .bg_blue
      background-color: $mainColor
      color: $white
      font-weight: bold
      padding: 5px 10px
      line-height: 180%
    .bg_lightblue
      background-color: $RepeatedOpeningColor
      color: $white
      font-weight: bold
      padding: 5px 10px
      line-height: 180%
    .el-input
      width: 120px
      font-size: 15px
      text-align: left
      .el-input__inner
        text-align: left
        line-height: 1px
      input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0
      &.borderRed
        .el-input__inner
          border: $dangerColorHover 1px solid

  .printPage
    display: none
</style>
<style lang="scss" scoped>
@media print{
  .printPage{
    table{
      border: 1px solid $borderDark2;
      font-size: 16px;
    }
    th{
      font-weight: bold;
      border: 1px solid $borderDark2;
      padding: 10px 5px;
    }
    td{
      border: 1px solid $borderDark2;
      padding: 10px 5px;
    }
  }
}
</style>
